export const isCrudFieldRequired = (row: any, column: any): boolean => {
  if (column.required instanceof Function) {
    return column.required(row);
  }

  return column.required;
};
